export enum AlertTypeEnum {
	TIP = 'tip',
	NOTE = 'note',
	WARNING = 'warning',
	DANGER = 'danger',
}

export interface IAlert {
	children: JSX.Element;
	type: AlertTypeEnum;
}
